import { useTranslation } from 'react-i18next'

import { TextFieldModel } from '@types'

import { TextArea } from '@components/TextArea'

import { Container } from './SubmitterFieldText.styled'

type SubmitterFieldTextProps = {
  field: TextFieldModel
  onChange: (updates: Partial<TextFieldModel>) => void
  disabled?: boolean
}

export const SubmitterFieldText: React.FC<SubmitterFieldTextProps> = ({
  field,
  onChange,
  disabled = false,
}: SubmitterFieldTextProps) => {
  const { t } = useTranslation()

  return (
    <Container>
      <TextArea
        hideOptional
        required={field.required}
        placeholder={t('modules_project-forms_components_FormSubmitter_components_SubmitterFieldText_placeholder')}
        label={field.label}
        value={field.value || ''}
        onChange={(value) => onChange({ value })}
        disabled={disabled}
      />
    </Container>
  )
}
